import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorBox } from "./components/common";
import ProjectList from "./components/ProjectList";
import ClientSearch from "./components/ClientSearch";
import { errorMessage, staffDmApi } from "./dmApi";
import "./dm.css";

/**
 * Digital Marketing landing page. Staff search / list DM-enrolled clients and open a client's
 * details page; portal users (api=portalDmApi) go straight to their own company's projects.
 */
function DMProjects({ api = staffDmApi, basePath = "/dm-projects" }) {
  const navigate = useNavigate();
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (api.isStaff) return;
    api.meta().then(setMeta).catch((err) => setError(errorMessage(err, "Could not load options")));
  }, [api]);

  return (
    <div className="dmp">
      <div className="dmp-header">
        <div>
          <h2 className="dmp-title">{api.isStaff ? "Clients" : "Digital Marketing"}</h2>
          {api.isStaff ? null : (
            <p className="dmp-subtitle">Your digital marketing projects: content, posts, campaigns and results</p>
          )}
        </div>
      </div>

      {api.isStaff ? (
        <div className="dmp-card dmp-card--clients">
          <ClientSearch api={api} onSelect={(t) => navigate(`${basePath}/client/${t.tenant_id}`)} />
        </div>
      ) : (
        <>
          <ErrorBox message={error} />
          <ProjectList api={api} meta={meta} basePath={basePath} />
        </>
      )}
    </div>
  );
}

export default DMProjects;
